import { FC } from "react";
import { Badge } from "@vilocnv/allsetra-core";
import { useTranslation } from "react-i18next";
import { KeyStatus } from "domain/keys/entities/dtos/key-history.dto";
import { getStatusText } from "domain/keys/utils/get-status-text";

type BadgeColorScheme =
  | "success"
  | "error"
  | "warning"
  | "grey"
  | "info"
  | "info-blue"
  | "purple"
  | "default";

export interface KeyHistoryStatusBadgeProps {
  statusCode: number;
}

const getStatusColorScheme = (statusCode: number): BadgeColorScheme => {
  switch (statusCode) {
    case KeyStatus.Active:
      return "success";
    case KeyStatus.Blocked:
      return "error";
    case KeyStatus.Deleted:
      return "error";
    case KeyStatus.Inventory:
      return "grey";
    default:
      return "default";
  }
};

const KeyHistoryStatusBadge: FC<KeyHistoryStatusBadgeProps> = ({
  statusCode
}) => {
  const { t } = useTranslation(["translation"]);
  const colorScheme = getStatusColorScheme(statusCode);
  const statusText = getStatusText(statusCode, t);

  return <Badge colorScheme={colorScheme}>{statusText}</Badge>;
};

export default KeyHistoryStatusBadge;
